export default {
    // Header Section
    "discover_your": "Discover Your",
    "personalized_report_2025": "Personalized Report 2025",
    "comprehensive_life_blueprint": "Comprehensive Life Blueprint",
    "personalized_report_2025_description": "Get your complete personalized astrological analysis for 2025. Comprehensive insights covering all life areas including career, love, finance, health, family, and spiritual growth with month-by-month guidance and personalized remedies.",

    // Service Information
    "enter_details_for_personalized_analysis": "Enter Your Details for Personalized Analysis 2025",
    "complete_personalized_analysis_2025": "Complete Personalized Analysis 2025",
    "service_price": "Service Price",
    "comprehensive_personalized_analysis_note": "Complete life analysis with 2025 predictions and personalized guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_personalized_analysis": "Your name creates unique vibrations for personalized astrological analysis",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_comprehensive_analysis": "Essential for comprehensive astrological chart and 2025 predictions",
    "time_of_birth": "Time of Birth",
    "exact_time_comprehensive_analysis": "Precise time needed for accurate house calculations and detailed analysis",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_personalized_analysis": "Location affects planetary positions for personalized predictions",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your personalized report will be delivered in the selected language",

    // Core 2025 Features
    "comprehensive_life_analysis": "Comprehensive Life Analysis",
    "year_2025_predictions": "Year 2025 Predictions",
    "all_life_areas_analysis": "All Life Areas Analysis",
    "personalized_remedies_solutions": "Personalized Remedies & Solutions",
    "monthly_guidance_2025": "Monthly Guidance 2025",
    "premium_pdf_report": "Premium PDF Report",

    "what_you_get": "What Your Personalized Report 2025 Includes",
    "complete_life_blueprint": "Complete Life Blueprint",
    "year_2025_forecast": "Year 2025 Forecast",
    "personalized_remedies": "Personalized Remedies",
    "monthly_predictions_guide": "Monthly Predictions Guide",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Personalized Report 2025",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "personalized_analysis_processing": "Your comprehensive personalized report for 2025 is being prepared by our expert astrologers. You'll receive detailed insights covering all life areas with month-by-month guidance.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_48_hours_delivery_note": "Your comprehensive personalized report will be ready within 48 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Personalized Report 2025 Package",
    "comprehensive_personalized_report": "Comprehensive Personalized Report (PDF)",
    "complete_2025_predictions": "Complete 2025 Predictions",
    "all_life_areas_detailed_analysis": "All Life Areas Detailed Analysis",
    "personalized_remedies_guide": "Personalized Remedies Guide",
    "monthly_action_plan_2025": "Monthly Action Plan 2025",

    // Visual Content
    "sample_personalized_analysis_2025": "Sample Personalized Analysis 2025",
    "year_2025_focus": "Year 2025 Focus",
    "sample_2025_reading": "Career growth and relationship stability with financial expansion",
    "sample_2025_preview": "Preview of your personalized 2025 analysis with comprehensive insights",
    "year_2025_analysis_areas": "Year 2025 Analysis Areas",

    // 2025 Life Area Types
    "career_2025": "Career 2025",
    "love_2025": "Love 2025",
    "finance_2025": "Finance 2025",
    "health_2025": "Health 2025",
    "family_2025": "Family 2025",
    "spiritual_2025": "Spiritual 2025",

    // Status & Processing
    "your_personalized_analysis_status": "Your Personalized Analysis Status",
    "processing_your_analysis": "Creating Your Personalized Report 2025",
    "analysis_processing_message": "Our expert astrologers are preparing your comprehensive personalized report covering all life areas with detailed 2025 predictions and month-by-month guidance.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_48_hours": "Report ready within 48 hours",

    // Support & Contact
    "contact_support": "Contact Premium Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // 2025 Year Overview
    "year_2025_overview": "Year 2025 Overview",
    "major_planetary_transits_2025": "Major Planetary Transits 2025",
    "key_astrological_events_2025": "Key Astrological Events 2025",
    "annual_theme_2025": "Annual Theme 2025",
    "yearly_opportunities": "Yearly Opportunities",
    "yearly_challenges": "Yearly Challenges",

    // Monthly Analysis 2025
    "january_2025": "January 2025",
    "february_2025": "February 2025",
    "march_2025": "March 2025",
    "april_2025": "April 2025",
    "may_2025": "May 2025",
    "june_2025": "June 2025",
    "july_2025": "July 2025",
    "august_2025": "August 2025",
    "september_2025": "September 2025",
    "october_2025": "October 2025",
    "november_2025": "November 2025",
    "december_2025": "December 2025",

    // Career 2025
    "career_forecast_2025": "Career Forecast 2025",
    "professional_growth_2025": "Professional Growth Opportunities",
    "job_changes_2025": "Job Changes & Transitions",
    "business_prospects_2025": "Business Prospects 2025",
    "leadership_opportunities_2025": "Leadership Opportunities",
    "salary_increment_timing": "Salary Increment Timing",
    "career_challenges_2025": "Career Challenges to Navigate",

    // Finance 2025
    "financial_forecast_2025": "Financial Forecast 2025",
    "income_growth_2025": "Income Growth Potential",
    "investment_opportunities": "Investment Opportunities",
    "expenditure_patterns": "Expenditure Patterns",
    "wealth_accumulation": "Wealth Accumulation Timeline",
    "financial_challenges": "Financial Challenges",
    "money_management_tips": "Money Management Tips",

    // Love & Relationships 2025
    "love_forecast_2025": "Love Forecast 2025",
    "relationship_developments": "Relationship Developments",
    "marriage_prospects_2025": "Marriage Prospects 2025",
    "family_harmony": "Family Harmony Forecast",
    "romantic_opportunities": "Romantic Opportunities",
    "relationship_challenges": "Relationship Challenges",
    "love_life_enhancement": "Love Life Enhancement",

    // Health 2025
    "health_forecast_2025": "Health Forecast 2025",
    "vitality_levels": "Vitality Levels Throughout 2025",
    "health_vulnerable_periods": "Health Vulnerable Periods",
    "wellness_recommendations": "Wellness Recommendations",
    "fitness_goals_2025": "Fitness Goals 2025",
    "mental_health_focus": "Mental Health Focus Areas",
    "preventive_care_guidance": "Preventive Care Guidance",

    // Spiritual Growth 2025
    "spiritual_journey_2025": "Spiritual Journey 2025",
    "meditation_practices": "Recommended Meditation Practices",
    "spiritual_awakening": "Spiritual Awakening Opportunities",
    "inner_growth_phases": "Inner Growth Phases",
    "divine_connections": "Divine Connections",
    "karmic_lessons_2025": "Karmic Lessons 2025",

    // Personalized Remedies
    "customized_remedies": "Customized Remedies for 2025",
    "gemstone_recommendations": "Gemstone Recommendations",
    "mantra_suggestions": "Mantra Suggestions",
    "ritual_guidance": "Ritual Guidance",
    "charitable_activities": "Beneficial Charitable Activities",
    "lifestyle_modifications": "Lifestyle Modifications",
    "lucky_colors_2025": "Lucky Colors for 2025",
    "auspicious_dates": "Auspicious Dates & Timing",

    // Timing & Cycles
    "auspicious_periods_2025": "Auspicious Periods 2025",
    "challenging_periods": "Challenging Periods to Navigate",
    "optimal_decision_timing": "Optimal Decision Making Times",
    "new_venture_timing": "New Venture Launch Timing",
    "travel_recommendations": "Travel Recommendations",
    "important_date_alerts": "Important Date Alerts",

    // Personal Development 2025
    "skill_development_2025": "Skill Development Focus 2025",
    "learning_opportunities": "Learning Opportunities",
    "personal_growth_areas": "Personal Growth Areas",
    "character_development": "Character Development Focus",
    "habit_formation": "Beneficial Habit Formation",
    "goal_achievement_strategy": "Goal Achievement Strategy",

    // Social & Networking 2025
    "social_connections_2025": "Social Connections 2025",
    "networking_opportunities": "Networking Opportunities",
    "friendship_developments": "Friendship Developments",
    "community_involvement": "Community Involvement",
    "social_influence_growth": "Social Influence Growth",

    // Technology & Innovation 2025
    "technology_adoption": "Technology Adoption Guidance",
    "digital_opportunities": "Digital Opportunities",
    "innovation_potential": "Innovation Potential",
    "online_presence": "Online Presence Enhancement",
    "digital_financial_growth": "Digital Financial Growth",

    // Travel & Relocation 2025
    "travel_forecast_2025": "Travel Forecast 2025",
    "relocation_possibilities": "Relocation Possibilities",
    "foreign_opportunities": "Foreign Opportunities",
    "pilgrimage_recommendations": "Pilgrimage Recommendations",
    "educational_travel": "Educational Travel",

    // Legal & Official Matters 2025
    "legal_matters_guidance": "Legal Matters Guidance",
    "official_work_timing": "Official Work Timing",
    "documentation_periods": "Favorable Documentation Periods",
    "government_dealings": "Government Dealings",
    "property_matters": "Property Related Matters",

    // Creative & Artistic 2025
    "creative_expression_2025": "Creative Expression 2025",
    "artistic_pursuits": "Artistic Pursuits",
    "creative_projects": "Creative Projects Timing",
    "artistic_collaborations": "Artistic Collaborations",
    "creative_income_potential": "Creative Income Potential",

    // Education & Knowledge 2025
    "educational_pursuits": "Educational Pursuits 2025",
    "skill_certifications": "Skill Certifications",
    "knowledge_expansion": "Knowledge Expansion Areas",
    "research_projects": "Research Projects",
    "teaching_opportunities": "Teaching Opportunities",

    // Environmental & Lifestyle 2025
    "living_environment": "Living Environment Changes",
    "lifestyle_upgrades": "Lifestyle Upgrades",
    "home_improvements": "Home Improvements Timing",
    "environmental_consciousness": "Environmental Consciousness",
    "sustainable_living": "Sustainable Living Practices"
};
